import { CarrierType, UNSPOTTED_TRACK_ID } from "../../utils/constants";
import { getLocationFullName } from "../../utils/locationUtils";

/**
 * Prefer API denormalized name when the record is a minimal track stub (e.g. from TrackCar).
 * Both branches go through getLocationFullName so the STAFF LEVEL FIX naming
 * (e.g. digit-only "5" -> "T-5") is applied even to stale denormalized values.
 */
export const getTrackLocationRecordDisplayName = (locationRecord) => {
  if (!locationRecord) return "";
  if (locationRecord.locationFullName) {
    return getLocationFullName(locationRecord.locationFullName);
  }
  return getLocationFullName(locationRecord);
};

export const getTrackDisplaySelectedTrack = ({
  inventoryItem,
  outbound,
  selectedLocation,
}) =>
  outbound
    ? selectedLocation || inventoryItem.location || null
    : inventoryItem.location || selectedLocation || null;

export const getTrackDisplayLocationName = ({
  inventoryItem,
  outbound,
  selectedLocation,
  locationName,
}) => {
  if (outbound && locationName) {
    return locationName;
  }

  const resolvedTrack = getTrackDisplaySelectedTrack({
    inventoryItem,
    outbound,
    selectedLocation,
  });

  if (resolvedTrack) {
    return getTrackLocationRecordDisplayName(resolvedTrack);
  }

  return getLocationFullName(inventoryItem.locationFullName);
};

export const shouldIncludeOutboundOption = ({
  outbound,
  inventoryItems,
  currentInventoryItemId,
}) => {
  return !inventoryItems.some(
    (inventoryItem) =>
      inventoryItem.outboundShipmentId === outbound.id &&
      inventoryItem.id !== currentInventoryItemId,
  );
};

export const getOutboundTrackId = (outboundShipment) =>
  outboundShipment?.trackCar?.trackId || "";

export const getSelectedOutboundTrackId = ({ outbounds, outboundId }) =>
  getOutboundTrackId(
    outbounds.find((outboundShipment) => outboundShipment.id === outboundId),
  );

export const isOutboundUnavailable = (outbound) => {
  const outboundTrackId = getOutboundTrackId(outbound);
  return !outboundTrackId || outboundTrackId === UNSPOTTED_TRACK_ID;
};

/**
 * Whether the crew still has to go spot this railcar. Deliberately narrower
 * than isOutboundUnavailable, which answers "can this car receive inventory"
 * and is also true when there is no TrackCar record at all — such a car has no
 * row to spot in Track Management, so gating on it would dead-end the crew.
 * Only a car parked in the Unspotted lane can be spotted. Collected cars have
 * their trackId cleared, so they fall out here too.
 */
export const needsOutboundRailcarSpotting = (outbound) =>
  outbound?.carrierType === CarrierType.RAIL &&
  outbound?.trackCar?.trackId === UNSPOTTED_TRACK_ID;

export const getSelectableOutbounds = ({
  outbounds,
  inventoryItems,
  currentInventoryItemId,
}) =>
  outbounds.filter((outbound) =>
    shouldIncludeOutboundOption({
      outbound,
      inventoryItems,
      currentInventoryItemId,
    }),
  );
